// Mock data for the trademark service website

export const services = [
  {
    id: 1,
    title: 'Trademark Registration',
    description: 'Protect your business identity with reliable and professionally managed trademark filing.',
    icon: 'Shield',
    link: '/trademark-registration',
    features: [
      'Complete USPTO filing',
      'Expert review',
      'Status tracking',
      'Legal compliance'
    ]
  },
  {
    id: 2,
    title: 'Copyright Registration',
    description: 'Safeguard your original content, creative work, and intellectual property..',
    icon: 'FileText',
    link: '/copyright-registration',
    features: [
      'Copyright filing',
      'Legal protection',
      'Quick processing',
      'Full documentation'
    ]
  },
  {
    id: 3,
    title: 'Trademark Search',
    description: 'Identify potential conflicts before filing through a comprehensive trademark search.',
    icon: 'Search',
    link: '/trademark-search',
    features: [
      'Comprehensive search',
      'Conflict analysis',
      'Detailed reports',
      'Risk assessment'
    ]
  },
  {
    id: 4,
    title: 'Amazon Brand Registry',
    description: 'Get enrolled in Amazon\'s Brand Registry to protect your products and boost sales.',
    icon: 'ShoppingBag',
    link: '/amazon-brand-registry',
    features: [
      'Brand protection',
      'Enhanced content',
      'Increased visibility',
      'Sales growth'
    ]
  },
  {
    id: 5,
    title: 'Company Formation',
    description: 'Start your business the right way with hassle-free company registration services.',
    icon: 'Building2',
    link: '/company-formation',
    features: [
      'LLC/Corp formation',
      'EIN registration',
      'State compliance',
      'Fast processing'
    ]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: 'Basic',
    price: 45,
    originalPrice: 55,
    recommended: false,
    description: 'Essential trademark protection for startups and small businesses.',
    features: [
      'Case Review',
      'Case Filing',
      'Basic Search',
      'State E-Filing',
      'Trademark Secured'
    ]
  },
  {
    id: 2,
    name: 'Deluxe',
    price: 145,
    originalPrice: 155,
    recommended: true,
    description: 'Enhanced protection with dedicated case management.',
    features: [
      'Case Review',
      'Case Filing',
      'Basic Search',
      'State E-Filing',
      'Trademark Secured',
      'Direct Hit Search',
      'Dedicated Case Manager'
    ]
  },
  {
    id: 3,
    name: 'Economy',
    price: 595,
    originalPrice: 755,
    recommended: false,
    description: 'Comprehensive protection with expert review and monitoring.',
    features: [
      'Case Review (by a TM Expert)',
      'Basic Free Trademark Search',
      'Trademark Monitoring Services (3 Months)',
      'Trademark Secured',
      'Refusal Risk Meter',
      'Case filing service with complete paperwork'
    ]
  },
  {
    id: 4,
    name: 'Elite',
    price: 895,
    originalPrice: 1055,
    recommended: false,
    description: 'Premium service with U.S. Registered IP Attorney and full protection.',
    features: [
      'Case Review & Filing (U.S Registered IP Attorney)',
      'Assigned Case Filing Officer',
      'Private Registration',
      'Federal Search & Clearance Report (All States)',
      'Federal E-Filing (USPTO)',
      'Cease & Desist Letter',
      'Same Day Filing',
      'Trademark Monitoring (1 Year)',
      'Trademark Secured',
      'Direct Hit Search',
      'Dedicated Case Manager',
      '24/7 Secure Online Access',
      '100% Approval Guarantee'
    ]
  }
];

export const copyrightPricing = [
  {
    id: 1,
    name: 'Gold',
    price: 99,
    recommended: false,
    description: 'Essential copyright protection for your creative works.',
    features: [
      'Professional Preparation of your federal copyright application',
      'Review by copyright team for accuracy and completeness',
      'Federal E-Filing with the USPTO',
      'Electronic filing with no paper files',
      'Certificate of Registration mailed directly from U.S. Copyright Office',
      '+ USPTO Filing Fee'
    ]
  },
  {
    id: 2,
    name: 'Diamond',
    price: 149,
    recommended: true,
    description: 'Premium copyright protection with expedited service.',
    features: [
      'Cease & Desist Letter (customer-specific form)',
      'Transfer/Assignment custom template',
      'Pre-filled templates you can customize',
      '24 Hours Expedited Process',
      'All features from Gold package',
      '+ USPTO Filing Fee'
    ]
  }
];

export const amazonBrandPricing = [
  {
    id: 1,
    name: 'Standard',
    price: 99,
    recommended: false,
    description: 'Essential Amazon brand protection.',
    features: [
      'Amazon Brand Case Review',
      'Amazon Brand Case Filing',
      '100% Satisfaction Guarantee',
      '+ USPTO filing fee'
    ]
  },
  {
    id: 2,
    name: 'Diamond',
    price: 149,
    recommended: true,
    description: 'Enhanced protection with risk assessment.',
    features: [
      'Amazon Brand Case Review',
      'Amazon Brand Case Preparation',
      'Amazon Brand Case Filing',
      '100% Satisfaction Guarantee',
      'Refusal Risk Meter',
      '+ USPTO filing fee'
    ]
  },
  {
    id: 3,
    name: 'Premium',
    price: 199,
    recommended: false,
    description: 'Complete solution with dedicated support.',
    features: [
      'Amazon Brand Case Review',
      'Amazon Brand Case Preparation',
      'Amazon Brand Case Filing',
      '100% Satisfaction Guarantee',
      'Refusal Risk Meter',
      'Amazon Brand Case Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
      '+ USPTO filing fee'
    ]
  }
];

export const trademarkSearchPricing = [
  {
    id: 1,
    name: 'Federal & State Search',
    price: 149,
    recommended: false,
    description: 'Comprehensive search across federal and state databases.',
    features: [
      'Federal trademark search (USPTO)',
      'State search across all 50 states',
      'Detailed online report',
      'Identifies similar names, logos, and slogans'
    ]
  },
  {
    id: 2,
    name: 'Federal, State & Common Law',
    price: 299,
    recommended: true,
    description: 'Extensive search including common law and corporate names.',
    features: [
      'Federal & State Search included',
      'Corporate name search (all 50 states)',
      'Corporate directories search',
      'Common law proprietary internet searches',
      'Domain name search',
      'Comprehensive conflict analysis'
    ]
  },
  {
    id: 3,
    name: 'Global Search',
    price: 499,
    recommended: false,
    description: 'International trademark search across multiple jurisdictions.',
    features: [
      'All Federal, State & Common Law features',
      'European Community search',
      'WIPO (World Intellectual Property Organization)',
      'Multi-national jurisdiction coverage',
      'Global domain name search'
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What is a trademark and why is it important?',
    answer: 'A trademark is a legal protection for your business name, logo, slogan, or other distinctive brand elements. It helps prevent others from using similar branding and strengthens your legal rights and brand recognition.'
  },
  {
    id: 2,
    question: 'How long does the trademark registration process take?',
    answer: "We can prepare and submit your trademark application within 24 hours after receiving your information. However, the USPTO's review and registration process typically takes several months, depending on the application and examination timeline."
  },
  {
    id: 3,
    question: 'What types of names or logos can be trademarked?',
    answer: 'You can trademark business names, brand names, logos, slogans, product names, and other unique identifiers that distinguish your products or services from competitors, provided they meet USPTO eligibility requirements.'
  },
  {
    id: 4,
    question: 'What is the difference between ™ and ®?',
    answer: 'The ™ symbol indicates that you are claiming trademark rights, even if the mark has not yet been federally registered. The ® symbol can only be used after your trademark has been officially registered with the USPTO.'
  },
  {
    id: 5,
    question: 'How much does trademark registration cost?',
    answer: 'Our trademark registration packages start at just $45, plus the applicable federal USPTO filing fee. Additional service packages are available for businesses that require enhanced protection and legal support.'
  },
  {
    id: 6,
    question: 'Can I register a trademark if someone else is using a similar name?',
    answer: 'It depends on how similar the name is and whether it could create confusion in the marketplace. We recommend conducting a professional trademark search before filing to identify potential conflicts and improve your chances of approval.'
  }
];

export const trademarkSearchResults = [
  {
    id: 1,
    name: 'TechFlow',
    status: 'Available',
    risk: 'Low',
    category: 'Technology',
    description: 'No conflicts found in USPTO database'
  },
  {
    id: 2,
    name: 'TechFlow Pro',
    status: 'Potential Conflict',
    risk: 'Medium',
    category: 'Technology',
    description: 'Similar trademark found - "TechFlo" registered in 2020'
  },
  {
    id: 3,
    name: 'Apple',
    status: 'Not Available',
    risk: 'High',
    category: 'Technology',
    description: 'Already registered - Apple Inc. trademark since 1977'
  },
  {
    id: 4,
    name: 'BrightPath',
    status: 'Available',
    risk: 'Low',
    category: 'Consulting',
    description: 'No conflicts found in USPTO database'
  },
  {
    id: 5,
    name: 'EcoGreen',
    status: 'Available',
    risk: 'Medium',
    category: 'Environment',
    description: 'Multiple similar names exist - recommend unique variation'
  }
];

export const howItWorks = [
  {
    step: 1,
    title: 'Share Your Information',
    description: 'Complete a short form with your brand details and business information.'
  },
  {
    step: 2,
    title: 'We Prepare & File',
    description: 'Our trademark specialists prepare and submit your application to the USPTO.'
  },
  {
    step: 3,
    title: 'Receive Brand Protection',
    description: 'After approval, your trademark is officially registered and legally protected.'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Professional Expertise',
    description: 'Our experienced specialists carefully prepare every filing to reduce errors and unnecessary delays.',
    icon: 'Award'
  },
  {
    id: 2,
    title: 'Quick & Hassle-Free Filing',
    description: 'We make the trademark process straightforward with an efficient online registration system.',
    icon: 'Zap'
  },
  {
    id: 3,
    title: 'Transparent Pricing',
    description: 'Enjoy affordable packages with clear pricing and absolutely no surprise costs.',
    icon: 'DollarSign'
  },
  {
    id: 4,
    title: 'Dedicated Customer Support',
    description: 'Receive expert guidance throughout every stage of your trademark journey.',
    icon: 'HeadphonesIcon'
  },
  {
    id: 5,
    title: 'Complete USPTO Compliance',
    description: 'Every application is prepared according to official legal requirements for greater accuracy.',
    icon: 'CheckCircle'
  }
];

export const partnerLogos = [
  { id: 1, name: 'Partner 1' },
  { id: 2, name: 'Partner 2' },
  { id: 3, name: 'Partner 3' },
  { id: 4, name: 'Partner 4' },
  { id: 5, name: 'Partner 5' },
  { id: 6, name: 'Partner 6' },
  { id: 7, name: 'Partner 7' }
];
